import { Button } from '@material-ui/core';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Table from 'components/Common/Table';

const StyledEnvironment = styled.div`
  .linkIndex {
    text-align: center;
    margin: 20px auto 0px auto;
  }
`;

/**
 * 動作環境のページ
 */
const Environment: FC = () => {
  return (
    <StyledEnvironment>
      <h2>動作環境</h2>
      <Table
        title="iOS/iPadOS(iPhone/iPad)"
        columns={['ブラウザ', '対応']}
        dataList={[
          ['Safari for iOS', '○'],
          ['Firefox for iOS', '○'],
          ['Chrome for iOS', '×'],
        ]}
      />
      <Table
        title="Android"
        columns={['ブラウザ', '対応']}
        dataList={[
          ['Chrome for Android', '○'],
          ['Firefox for Android', '×'],
          ['Edge for Android', '○'],
        ]}
      />
      <Table
        title="Mac OSX"
        columns={['ブラウザ', '対応']}
        dataList={[
          ['Safari', '△'],
          ['Chrome', '○'],
          ['Firefox', '○'],
        ]}
      />
      <Table
        title="Windows"
        columns={['ブラウザ', '対応']}
        dataList={[
          ['Internet Explorer', '×'],
          ['Edge', '△'],
          ['Chrome', '○'],
          ['Firefox', '○'],
        ]}
      />
      <div className="linkIndex">
        <Button variant="contained" color="primary" component={Link} to="/">
          前のページへ戻る
        </Button>
      </div>
    </StyledEnvironment>
  );
};

export default Environment;
